import React from 'react';
import PropTypes from 'prop-types';
import ErrorBanner from '../../../components/ErrorBanner';

CancelledBanner.propTypes = {
  event: PropTypes.object.isRequired
};

export default function CancelledBanner(props) {
  const { event } = props;

  if (event.data.cancelled) {
    return (
      <ErrorBanner
        title="Event was cancelled for the following reason:"
        subtitle={event.data.cancelledMessage || '[No reason provided]'}
      />
    );
  }

  return null;
}
